import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { GovukpayPageRoutingModule } from './govukpay-routing.module';

import { GovukpayPage } from './govukpay.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    GovukpayPageRoutingModule
  ],
  declarations: [GovukpayPage]
})
export class GovukpayPageModule {}
